import { QuotientModalCloseButton } from './ModalCloseButton';

export const QuotientDrawerCloseButton = QuotientModalCloseButton;
